<template>
<div style="width: 100%">
  <div class="innerBox">
    <div class="bodyTitle">
      <el-input v-model="searchInput" placeholder="请输入内容" size="small"></el-input>
      <el-button icon="el-icon-search" size="small" type="primary" @click="search"></el-button>
    </div>
    <el-table
      :data="tableData"
      :header-cell-style="{'background-color': 'rgb(250,250,250)', 'color': 'black', 'font-weight': '400'}"
      style="width: 100%">
      <el-table-column
        prop="number"
        label="区域编号">
      </el-table-column>
      <el-table-column
        prop="cellName"
        label="区域名称" min-width="100px">
      </el-table-column>
      <el-table-column
        label="固有风险等级">
        <template slot-scope="{ row }">
          <span v-if="row.inherentRiskLevel === 0">重大风险（I）</span>
          <span v-if="row.inherentRiskLevel === 1">较大风险（II）</span>
          <span v-if="row.inherentRiskLevel === 2">一般风险（III）</span>
          <span v-if="row.inherentRiskLevel === 3">低风险（IV）</span>
        </template>
      </el-table-column>
      <el-table-column
        label="控制风险等级" min-width="105px">
        <template slot-scope="{ row }">
          <span v-if="row.controlRiskLevel === 0">重大风险（A）</span>
          <span v-if="row.controlRiskLevel === 1">较大风险（B）</span>
          <span v-if="row.controlRiskLevel === 2">一般风险（C）</span>
          <span v-if="row.controlRiskLevel === 3">低风险（D）</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="calibrationLevel"
        label="级别校正">
      </el-table-column>
      <el-table-column
        label="控制风险数量">
        <template slot-scope="{ row }">
          <span @click="jumpTwoOrder(row)" class="wordBtn">{{ row.controlNum }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="区域风险等级"
        prop="romanRiskLevel"
      >
      </el-table-column>
      <el-table-column label="风险等级">
        <template slot-scope="{ row }">
          <el-tag v-if="row.result === 0" effect="dark" type="danger" size="small">重大风险</el-tag>
          <el-tag v-if="row.result === 1" effect="dark" type="warning" size="small">较大风险</el-tag>
          <el-tag v-if="row.result === 2" effect="dark" style="color: #666666;background: yellow;borderColor: yellow" size="small">一般风险</el-tag>
          <el-tag v-if="row.result === 3" effect="dark" size="small">低风险</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="evaluateDepName"
        label="评价人所在部门">
      </el-table-column>
      <el-table-column
        prop="evaluateEmpName"
        label="评价人">
      </el-table-column>
      <el-table-column
        prop="reEvaluationTime"
        label="复评时间">
      </el-table-column>
      <el-table-column
        label="操作"
        width="50">
        <template slot-scope="{ row }">
          <span v-if="userId === row.evaluateUserId" class="wordBtn" @click="operation(row)">评价</span>
        </template>
      </el-table-column>
    </el-table>
    <div style="text-align:right;margin-top:15px">
      <Page :total="total" :page-size="limit" :current="curPage" @on-change="onChange" />
    </div>
  </div>
  <risk-evaluation v-bind='{ status: status,sendMessage: sendMessage }' @backMsg='backMsg'></risk-evaluation>
</div>
</template>

<script>
import riskEvaluation from './riskEvaluation'
import { getFxListNew, searchFxList, withResult } from '@/api/processManager'
export default {
  name: 'riskManagement',
  components: {
    riskEvaluation,
  },
  filters: {
    // 计算区域风险等级
    Calculator(val1,val2) {
      let riskMatrix = ""
      let controlLevel = ""
      switch(val1){
        case 0:
          riskMatrix = "I"
          break
        case 1:
          riskMatrix = "II"
          break
        case 2:
          riskMatrix = "III"
          break
        case 3:
          riskMatrix = "IV"
          break
      };
      switch(val2){
        case 0:
          controlLevel = "A"
          break
        case 1:
          controlLevel = "B"
          break
        case 2:
          controlLevel = "C"
          break
        case 3:
          controlLevel = "D"
          break
      }
      return riskMatrix + controlLevel
    },
    // 计算最终分级结果
    Calculator2(val1, val2, val3) {
      let num = 0
      if(val1 === 0) {
        num = 3
      }else if(val1 === 1) {
        num = 2
      }else if(val1 === 2){
        num = 1
      }else{
        num = 0
      }
      let a = num + val3
      if(val2 === 3) {
        if(a === 0) {
          return '低风险'
        }else if(a === 1){
          return '一般风险'
        }else if(a === 2){
          return '较大风险'
        }else{
          return '重大风险'
        }
      }
      if(val2 === 2){
        if(a === 0 || a === 1) {
          return '一般风险'
        }else if(a === 2){
          return '较大风险'
        }else{
          return '重大风险'
        }
      }
      if(val2 === 1) {
        if(a === 0 || a === 1){
          return '较大风险'
        }else{
          return '重大风险'
        }
      }
      if(val2 === 0){
        return '重大风险'
      }
    }
  },
  data() {
    return {
      userId: '',
      searchInput: '',
      tableData: [],
      status: false,
      sendMessage: null,
      total: 10,
      limit: 10,
      curPage: 1,
      riskMatrixList: ["I(重大风险)","II(较大风险)","III(一般风险)","IV(低风险)"],
      controlLevelList: ["A(重大风险)","B(较大风险)","C(一般风险)","D(低风险)"]
    }
  },
  methods: {
    // 搜索事件
    search() {
      if(this.searchInput === '') {
        return
      }
      this.getList()
    },
    // 点击评价
    operation(row) {
      // console.log(row)
      this.sendMessage = row
      this.status = !this.status
    },
    // 子组件传回来的值
    backMsg(val, val2) {
      this.status = val
      if(val2) {
        this.getList()
      }
    },
    // 获取列表
    getList() {
      let result = ''
      if(this.$route.query.result || this.$route.query.result === 0){
        result = this.$route.query.result
      }
      getFxListNew({ limit: this.limit, curPage: this.curPage, result: result, cellName: this.searchInput }).then((res) => {
        this.total = res.body.data.cum
        this.tableData = res.body.data
      })
    },
    // 翻页的事件
    onChange(val) {
      this.curPage = val
      this.getList()
    },
    // 点击控制风险数量，跳到两单管理
    jumpTwoOrder(row) {
      this.$router.push(
        {
          path: 'twoOrderNew',
          query: {
            id: row.id,
            status: 'second'
          }
        }
      )
      // console.log(val)
    },
  },
  // 输入框为空的时候请求全部列表
  watch: {
    searchInput(val) {
      if(val === "") {
        this.getList()
      }
    }
  },
  created() {
    this.getList()
    this.userId = Number(localStorage.getItem('userId'))
  }
}
</script>

<style scoped>
  .innerBox {
    margin: auto;
    width: 100%;
    height: 100%;
    padding: 0 15px 15px 15px;
    border: 1px solid rgb(232,232,232);
    background-color: white;
  }
  .bodyTitle {
    width: 16%;
    margin-top: 12px;
    margin-bottom: 20px;
    display: flex;
  }
  .bodyTitle .el-button {
    margin-left: -2px;
    z-index: 999;
    border-left: none;
    border-radius: 0 4px 4px 0
  }
  .wordBtn {
    color: #1890ff;
    cursor: pointer;
  }
</style>
